export default "__VITE_ASSET__DV$oZuqk__"